import { isAPP } from './util';
import astConfig from './config';
import { common } from '@tencent/ceiba-base-components';
import { filtUrlParams } from './filt-url-params';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import Vue from 'vue';

export default {
  components: { [CDialog.name]: CDialog },
  initTgclubTopbar(meta) {
    console.log('initTgclubTopbar======================meta=', meta);
    console.log('reportClickRawbeforeCloseAction', this);
    // eslint-disable-next-line
    if (window['__PRERENDER_INJECTED']?.topbar === false) {
      return;
    }

    /**
     * 判断APP版本是否大于等于给定版本
     * @param {string[]} criticality 给定版本 如 ['5', '8', '4']
     */
    function appVersion(criticality) {
      if (typeof (criticality) !== 'object') {
        return false;
      }
      let str = navigator.userAgent.toLowerCase();
      if (str.match('tgclub') === null) {
        return false;
      }
      str = str.substring(str.indexOf('tgclub/') + 7, 12);
      const versionArr = str.split('.');
      if (+versionArr[0] > +criticality[0]) {
        return true;
      }
      if (versionArr[0] === criticality[0] && +versionArr[1] > +criticality[1]) {
        return true;
      }
      if (versionArr[0] === criticality[0] && versionArr[1] === criticality[1]) {
        if (!(/ipad|iphone|ipod/ig.test(navigator.userAgent.toLowerCase()))) {
          if (parseInt(versionArr[2], 10) >= criticality[2]) {
            return true;
          }
          return false;
        }
        const helpArr = versionArr[2].split(' ');
        if (parseInt(helpArr[0], 10) >= criticality[2]) {
          return true;
        }
        return false;
      }
      return false;
    }

    function getDevice() {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      if (isAndroid) return 'android';
      if (isiOS) return 'ios';
      return 'android'; // 默认安卓
    }

    window.cleanCallback = () => {
      beforeCloseActionDialog.style.display = 'block';
      console.log('reportClickRaw.typeof Vue.prototype', typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function');
      // 弹框显示 埋点上报
      if (typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function') {
        const params = {
          // ceibaComponentId: `${this.cid}`,
          // ceibaComponentUid: this.uid,
          ceibaComponentUname: '挽留弹框曝光',
          eventKey: 'dialog_expose',
          eventData: {
            stage: 2,
          },
        };
        console.log('reportClickRaw.params', params);
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
      }
    };

    function addTgclubJsApiCallback(apiName) {
      let platform = 'browser';
      const ua = navigator.userAgent;
      if (ua.match(/MicroMessenger/i)) platform = 'wx';
      else if (ua.match(/tgclub/i)) platform = 'tgclubApp';
      else if (ua.match(/QQ\/[0-9]/i)) platform = 'qq';
      console.log('TgclubJsApiRequireVersion.platform', platform);
      console.log('TgclubJsApiRequireVersion.apiName', apiName);
      if (platform === 'tgclubApp' && appVersion(['5', '8', '5'])) {
        const run = () => {
          console.log('TgclubJsApiRequireVersion.run');
          const eventId = window.UPBridge[apiName];
          document.addEventListener(eventId, (e) => {
            window.cleanCallback();
          });
        };
        const iosRun = () => {
          console.log('TgclubJsApiRequireVersion.iosRun');
          // 事件类型功能
          // const eventId = window.UPBridge[apiName];
          // document.addEventListener(eventId, (e) => {
          //   window.cleanCallback();
          // })
          const eventId = window.UPBridge[apiName];
          document.addEventListener(eventId, (e) => {
            window.cleanCallback();
          });
        };
        if (window.UPBridge && isAPP()) {
          console.log('TgclubJsApiRequireVersion.TgclubReady', 4545);
          run();
        } else {
          console.log('TgclubJsApiRequireVersion.TgclubReady', 1212);
          // document.addEventListener('TgclubReady', run);
          window.document.addEventListener(
            'TgclubReady',
            iosRun,
            true,
          );
        }
      } else {
        const msg = `非APP或者app版本不支持${apiName}`;
        console.warn(msg);
      }
    }

    // 获取当前周  周末的时间戳
    function getTimeStr() {
      const nowData = new Date();
      let currentDay = nowData.getDay();
      if (currentDay === 0) {
        currentDay = 7;
      }
      const sunDayTime = nowData.setHours(23, 59, 59) + (7 - currentDay) * 24 * 60 * 60 * 1000;
      return sunDayTime;
    }

    // 设置频率
    function getFrequency() {
      // 本地缓存key
      const key = `beforeCloseActionFrequency12${common.tool.getCookie('openid') || common.tool.getCookie('uin')}`;
      let val = window.localStorage.getItem(key);
      console.log('TgclubJsApiRequireVersion.getFrequency', key);
      // 如果没有值就直接返回null
      if (!val) {
        return true;
      }
      // 存在
      val = JSON.parse(val);
      console.log('TgclubJsApiRequireVersion.getFrequency', val);
      // 已满三次
      if (val.value >= 3) {
        return false;
      }
      const nowTimeStr = new Date().getTime();
      // 本周已弹
      if (nowTimeStr <= parseInt(val.time, 10)) {
        return false;
      }
      return true;
    }

    function setFrequency() {
      // 本地缓存key
      if (!common.tool.getCookie('openid')) {
        return;
      }
      const key = `beforeCloseActionFrequency12${common.tool.getCookie('openid')}`;
      let val = window.localStorage.getItem(key);
      console.log('TgclubJsApiRequireVersion.setFrequency', key);
      // 如果没有值就直接返回null
      if (!val) {
        const obj = {
          value: 1, // 存储值
          time: getTimeStr(), // 存值的比较时间戳
        };
        console.log('TgclubJsApiRequireVersion.setFrequency', obj);
        window.localStorage.setItem(key, JSON.stringify(obj));
      } else {
        // 存在
        val = JSON.parse(val);
        console.log('TgclubJsApiRequireVersion.setFrequency', val);
        // 未满三次
        // 本周已更新记录  无需再去记录
        const nowTimeStr = new Date().getTime();
        if (nowTimeStr <= parseInt(val.time, 10)) {
          return;
        }
        const obj = {
          value: val.value + 1, // 存储值
          time: getTimeStr(), // 存值的比较时间戳
        };
        console.log('TgclubJsApiRequireVersion.setFrequency', obj);
        window.localStorage.setItem(key, JSON.stringify(obj));
      }
    }
    // 返回对象
    function getUrlVars(url) {
      const vars = {};
      url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
        vars[key] = value;
      });
      return vars;
    }
    // 获取url后的参数
    const oUrl = window.location.href;
    console.log(getUrlVars(oUrl));

    // 插入样式
    const beforeCloseActionStyle = document.createElement('style');
    beforeCloseActionStyle.type = 'text/css';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction{display:none;height: 100vh;width: 100%;position:fixed;top:0;left:0;z-index:9999;background:rgba(0,0,0,0.5)}';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction .beforeCloseActionPop{height: 5.44rem;width:6rem;min-height:1.6rem;box-sizing:border-box;padding-bottom:1rem;position:relative;background:#fff;border-radius:.3rem;overflow:hidden;position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:9998}';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction .beforeCloseActionPop .beforeCloseActionPop-text{margin: 0.48rem auto;width: 4.46rem;height: 0.84rem;font-family: \'PingFang SC\';font-style: normal;font-weight: 400;font-size: 0.28rem;line-height: 0.42rem;color: #242424;flex: none;order: 0;flex-grow: 0;}';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction .beforeCloseActionPop .btnbar{position:absolute;bottom:0;left:0;width:100%;height:1rem;display:-webkit-flex;display:flex;align-items:center;border-top:.1px solid #f3f3f3}';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction .beforeCloseActionPop .btnbar a{text-decoration:none;flex:1;box-sizing:border-box;height:1.12rem;display:-webkit-flex;display:flex;align-items:center;justify-content:center;color:#ba8341;font-size:.3rem;font-weight:700}';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction .beforeCloseActionPop .btnbar a:first-child{border-right:.1px solid #B68950;}';
    beforeCloseActionStyle.innerHTML += '.beforeCloseAction .beforeCloseActionPop .beforeCloseAction-img{width: 6rem;height: 2.68rem;background: linear-gradient(180deg, #F7F7F7 0%, #FFFFFF 100%);flex: none;order: 1;flex-grow: 0;}';
    const headTag1 = document.head || document.getElementsByTagName('head')[0];
    headTag1.appendChild(beforeCloseActionStyle);
    // 插入弹窗
    const beforeCloseActionDialog = document.createElement('div');
    beforeCloseActionDialog.className = 'beforeCloseAction';
    // 6.0以下需要绑定角色
    let imgVal = 'https://act.xinyue.qq.com/activity/tgclub/10420/e1e2c5d29d2a51b9ec81625e4d283ed5.png';
    let textVal = '退出后可通过搜索活动对应的游戏，进入对应的游戏专区后找到当前活动';
    if (appVersion(['6', '0', '0'])) {
      // 6.0及以上的文案和图片
      imgVal = 'https://act.xinyue.qq.com/activity/tgclub/10420/0d1cbdeef90482fbbaa94b7912a3283a.png';
      textVal = '退出后可通过进入首页的精选活动-更多，找到当前活动';
    } else {
      if (!Vue.prototype.$actInfo?.extendConfig?.forceRole) {
        imgVal = 'https://act.xinyue.qq.com/activity/tgclub/10420/7ea79f66a243752121deabd368f9fa3f.png';
        textVal = '退出后可通过进入权益tab或会员Tab的热门活动，找到当前活动';
      }
    }
    console.log('actInfo.extendConfig', Vue.prototype.$actInfo?.extendConfig?.forceRole);
    beforeCloseActionDialog.innerHTML = `${`${'<div class="beforeCloseActionPop">'
      + '<img class="beforeCloseAction-img" src="'}${imgVal}">`
      + '<p class="beforeCloseActionPop-text">'}${textVal}</p>`
      + '<div class="btnbar">'
      + '<a class="beforeCloseAction-sure" href="javascript:;">知道了</a>'
      + '</div>'
      + '</div>';
    const htmlTag1 = document.getElementsByTagName('html')[0];
    htmlTag1.appendChild(beforeCloseActionDialog);
    beforeCloseActionDialog.getElementsByClassName('beforeCloseAction-sure')[0].onclick = function () {
      //  点击知道了  埋点上报
      if (typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function') {
        const params = {
          // ceibaComponentId: `${this.cid}`,
          // ceibaComponentUid: this.uid,
          // ceibaComponentUname: this.uname,
          eventKey: 'dialog_close',
          eventData: {
            stage: 2,
          },
        };
        console.log('reportClickRaw.params', params);
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
        console.log('reportClickRaw.reportFlush', Vue.prototype?.$storeInstance?._actions?.reportFlush);
      }
      setTimeout(() => {
        Vue.prototype?.$storeInstance?._actions?.reportFlush[0]();
        setFrequency();
        beforeCloseActionDialog.style.display = 'none';
        // getDevice() === 'android' ? window.UPBridge?.beforeCloseAction('') : window.UPBridge?.beforeCloseAction();
        window.UPBridge?.beforeCloseAction();
        window.UPBridge?.closeWebview();
      }, 200);
    };
    console.log('beforeCloseActionDialog.window.CEIBA_ENV', window.CEIBA_ENV);
    if (isAPP() && getFrequency()) {
      addTgclubJsApiCallback('beforeCloseAction');
    }
    // isClose
    const isCloseTgclubTopBar = common.tool.getQueryparams('closeTgclubTopBar');
    if (isAPP() || isCloseTgclubTopBar) {
      return;
    }
    // 插入样式
    const popImg = 'https://game.gtimg.cn/images/js/img/tgclub/tgclubLogo.png';
    const popPrivacy = 'https://xinyue.qq.com/cp/a2019101025app/xy_privacy202201.html';
    const popLimit = 'https://xinyue.qq.com/cp/a2019101025app/userAgreement.html';
    const popProduct = 'https://xinyue.qq.com/act/a20230103joyclub/public/productFeatures/index.html';
    const pubTopBarStyle = document.createElement('style');
    pubTopBarStyle.type = 'text/css';
    pubTopBarStyle.innerHTML = '.xy-download{display:-webkit-flex;display:flex}';
    pubTopBarStyle.innerHTML += '.xy-download{-webkit-align-items:center;align-items:center;-webkti-justify-rection:space-between;justify-content:space-between;height:1.2rem;background:#fff;-webkit-box-shadow:0 0 .1rem rgba(0,0,0,.3);box-shadow:0 0 .1rem rgba(0,0,0,.3);padding:0;margin:0;padding:0 .36rem}';
    pubTopBarStyle.innerHTML += '.xy-logo{height:.8rem;width:3.08rem;display:-webkit-flex;display:flex;-webkti-justify-rection:space-between;justify-content:space-between;}';
    pubTopBarStyle.innerHTML += '.xy-logo-title{height:.8rem;width:2.08rem;}';
    pubTopBarStyle.innerHTML += '.xy-logo-business{font-size: 0.32rem;font-weight: 500;}';
    pubTopBarStyle.innerHTML += '.xy-logo-text{font-size: 0.24rem;color: #8E8E93}';
    pubTopBarStyle.innerHTML += '.xy-logo-image{height:.8rem;width:.8rem;background-image:url(https://game.gtimg.cn/images/js/img/tgclub/tgclubLogo.png);background-size:cover;border-radius: 10px;}';
    pubTopBarStyle.innerHTML += '.xy-download-btn{height:.64rem;width:1.8rem;background-color: #D7B386;border-radius: 8px;font-size: 0.24rem;color: #fff;display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center;justify-content:center;}';
    pubTopBarStyle.innerHTML += '.confirmDialog{display:none;height: 100vh;width: 100%;position:fixed;top:0;left:0;z-index:9999;background:rgba(0,0,0,0.5)}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop{width:5.5rem;min-height:1.6rem;box-sizing:border-box;padding-bottom:1rem;position:relative;background:#fff;border-radius:.3rem;overflow:hidden;text-align:center;position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:9998}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .confirmDialogPop-text{width:100%;height:.4rem;display:-webkit-flex;display:flex;align-items:center;justify-content:center;color:#919191;font-size:.2rem}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .btnbar{position:absolute;bottom:0;left:0;width:100%;height:1rem;display:-webkit-flex;display:flex;align-items:center;border-top:.1px solid #f3f3f3}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .btnbar a{text-decoration:none;flex:1;box-sizing:border-box;height:1rem;display:-webkit-flex;display:flex;align-items:center;justify-content:center;color:#000;font-size:.26rem;font-weight:700}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .btnbar a:first-child{border-right:.1px solid #f3f3f3}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .btnbar .btn-sure{color:#616f89}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .confirmDialogPop-title{width:100%;height:1.4rem;display:-webkit-flex;display:flex;align-items:center;justify-content:center;color:#000;font-size:.4rem}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .title-name{height:.5rem;font-size:.3rem;margin-top:.3rem}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .confirmDialogPop-img{width:1rem;height:1rem;margin:0 auto;border-radius:.2rem}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .confirmDialogPop-rules{width:100%;height:.4rem;display:-webkit-flex;display:flex;align-items:center;justify-content:center;color:#919191;font-size:.2rem;margin-bottom:.2rem}';
    pubTopBarStyle.innerHTML += '.confirmDialog .confirmDialogPop .rules-link{color:#919191;font-size:.2rem;text-decoration:underline;margin-left:.1rem;margin-right:.1rem}';

    const headTag = document.head || document.getElementsByTagName('head')[0];
    headTag.appendChild(pubTopBarStyle);
    // 插入结构
    const pubTopBar = document.createElement('div');
    pubTopBar.className = 'xy_topbar';
    pubTopBar.innerHTML = '<div class=\'xy-download\'><div class=\'xy-logo\'><div class=\'xy-logo-image\'></div>'
      + '<div class=\'xy-logo-title\'><p class=\'xy-logo-business\'>心悦俱乐部</p><p class=\'xy-logo-text\'>腾讯游戏福利平台</p></div></div>'
      + '<a class=\'xy-download-btn\' href=\'javascript:;\'>立即打开</a></div>';
    let bodyTag = document.getElementsByTagName('body')[0];
    if (bodyTag.querySelector('.page-scroll')) {
      bodyTag = bodyTag.querySelector('.page-scroll');
    }
    if (getUrlVars(oUrl).site === 'bot') {
      bodyTag.append(pubTopBar);
    } else {
      bodyTag.prepend(pubTopBar);
    }
    // 插入弹窗
    const confirmDialog = document.createElement('div');
    confirmDialog.className = 'confirmDialog';
    confirmDialog.innerHTML = '<div class="confirmDialogPop">'
      + '<strong class="confirmDialogPop-title">即将为你下载</strong>'
      + `${'<p><img class="confirmDialogPop-img" src="'}${popImg}"></p>`
      + '<strong class="confirmDialogPop-title title-name">心悦俱乐部</strong>'
      + '<p class="confirmDialogPop-text">开发者:深圳市腾讯计算机系统有限公司</p>'
      + '<p class="confirmDialogPop-text">运营者:深圳市腾讯计算机系统有限公司</p>'
      + '<p class="confirmDialogPop-text">心悦俱乐部6.2.5.50</p>'
      + `${'<p class="confirmDialogPop-rules"><a class="rules-link" href="'}${popPrivacy}">隐私政策</a>|<a class="rules-link" href="${popLimit}">应用权限</a></p>`
      + '<div class="btnbar">'
      + '<a class="btn-cancle" href="javascript:;">取消</a>'
      + '<a class="btn-sure" href="javascript:;">确定</a>'
      + '</div>'
      + '</div>';
    const htmlTag = document.getElementsByTagName('html')[0];
    htmlTag.appendChild(confirmDialog);
    if (typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function') {
      const params = {
        // ceibaComponentId: `${this.cid}`,
        // ceibaComponentUid: this.uid,
        // ceibaComponentUname: this.uname,
        eventKey: 'topbar_expose',
      };
      console.log('reportClickRaw.params', params);
      Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
      console.log('reportClickRaw.reportFlush', Vue.prototype?.$storeInstance?._actions?.reportFlush);
    }
    window.pubTopBarLock = 'unlock';

    function goAPP() {
      event.preventDefault();
      event.stopPropagation();
      if (window.pubTopBarLock === 'lock') {
        return;
      }
      window.pubTopBarLock = 'lock';
      let url = window.location.href;
      // 强制更新成活动traceId
      const traceId = window.ceibaTraceId;
      url = common.tool.setUrlParam('trace_id', traceId, url);
      url = filtUrlParams(url);
      // 跳转tgclub:// 最外层协议 需要加上 trace_id
      const schemaUrl = `tgclub://redirect?url=${encodeURIComponent(url)}&share=1&trace_id=${traceId}`;
      const gSUA = navigator.userAgent.toLowerCase();
      const android = gSUA.match(/(android)\s+([\d.]+)/);
      const ios = gSUA.match(/(ipad|iphone|ipod).*os\s([\d_]+)/);
      const isWeixin = gSUA.match(/micromessenger/);
      const isQq = gSUA.match(/QQ\/[0-9]/i);
      // const loadDateTime = Date.now();
      // const iframe = document.createElement('iframe');
      if (gSUA.indexOf('tgclub') === -1) {
        switch (true) {
          case (ios !== null && isWeixin !== null): // ios微信
          {
            // IOS的微信，使用JSAPI唤起
            setTimeout(() => {
              window.WeixinJSBridge.invoke('launchApplication', {
                schemeUrl: schemaUrl,
              });
            }, 500);
            // 手Q直接跳转
            jumpDownApp(3000);
            break;
          }
          case (ios !== null && isQq !== null): // ios 手Q
          {
            window.location.href = schemaUrl;
            const loadDateTime = Date.now();
            setTimeout(() => {
              const timeOutDateTime = Date.now();
              if (timeOutDateTime - loadDateTime < 1000) {
                jumpDownApp(3000);
              }
            }, 25);
            break;
          }
          case (ios !== null && isQq === null && isWeixin === null): // ios 浏览器
            window.location.href = schemaUrl;
            jumpDownApp(1500);
            break;
          case (android !== null && isWeixin !== null):// 安卓 微信
            // IOS的1微信，使用JSAPI唤起
            setTimeout(() => {
              window.WeixinJSBridge.invoke('launchApplication', {
                schemeUrl: schemaUrl,
              });
            }, 500);
            // 手Q直接跳转
            jumpDownApp(1500);
            break;
          case (android !== null && isWeixin === null): // 安卓 手Q
          {
            const iframe = document.createElement('iframe');
            iframe.src = schemaUrl;
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            // 手Q直接跳转
            jumpDownApp(1500);
            break;
          }

          case (android !== null && isQq === null && isWeixin === null): // android 浏览器
          {
            const iframe = document.createElement('iframe');
            iframe.src = schemaUrl;
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            jumpDownApp(1500);
            break;
          }
          default:
            // alert('仅适用IOS或Android')
            window.pubTopBarLock = 'unlock';
            break;
        }
      }
    }

    function jumpDownApp(delayTime) {
      setTimeout(() => {
        window.pubTopBarLock = 'unlock';
        confirmDialog.style.display = 'block';
      }, delayTime);
    }

    function downApp() {
      let appDownUrl;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        appDownUrl = 'https://itunes.apple.com/cn/app/%E5%BF%83%E6%82%A6%E4%BF%B1%E4%B9%90%E9%83%A8-%E8%85%BE%E8%AE%AF%E6%B8%B8%E6%88%8F%E7%8E%A9%E5%AE%B6%E7%A6%8F%E5%88%A9%E5%B9%B3%E5%8F%B0/id1156439976?mt=8';
        window.location.href = appDownUrl;
      } else {
        appDownUrl = 'http://dlied5.myapp.com/myapp/6337/tgclub/apk/20200729/cdf9f187052a10bc6109394055721112.apk';
        window.location.href = appDownUrl;
      }
    }

    document.getElementsByClassName('xy-download-btn')[0].onclick = function () {
      goAPP();
      if (typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function') {
        const params = {
          // ceibaComponentId: `${this.cid}`,
          // ceibaComponentUid: this.uid,
          // ceibaComponentUname: this.uname,
          eventKey: 'topbar_click',
        };
        console.log('reportClickRaw.params', params);
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
        console.log('reportClickRaw.reportFlush', Vue.prototype?.$storeInstance?._actions?.reportFlush);
      }
    };
    confirmDialog.getElementsByClassName('btn-cancle')[0].onclick = function () {
      confirmDialog.style.display = 'none';
    };
    confirmDialog.getElementsByClassName('btn-sure')[0].onclick = function () {
      downApp();
    };
  },
  initBbTopbar(meta) {
    // eslint-disable-next-line
    if (window['__PRERENDER_INJECTED']?.topbar === false) {
      return;
    }
    window.onWebShow = {};
    console.log('initBbTopbar======================meta=', meta);
    if (isAPP()) {
      console.log('loadScript');
      return;
      // common.tool.loadScript("bbfooter", "//bb.img.qq.com/bbcdn/act/dnf/downloadBanner/banner.js", callback())
    }
    const gid = Vue.prototype.$actInfo?.gid;
    if (!astConfig.BB?.GAMEINFO[gid]?.name) {
      // 不在助手游戏列表内,直接返回
      return;
    }
    const gameId = astConfig.BB?.GAMEINFO[gid]?.gameId || '0';
    const subGameId = astConfig.BB?.GAMEINFO[gid]?.subGameId || '0';
    const bannerParamsDL = {
      position: 'bottom',                        // iframe位置，默认底部
      attrClass: 'down-iframe',                  // iframe标签和外层div的class属性
      attrName: 'DBFrame',                       // iframe的name属性
      scale: 0.14,                               // 宽高比，默认w/h=0.2
      page: '/act/dnf/downloadBanner/index',     // 加载页面
      background: '#000000',                     // 背景色
      color: '#FFFFFF',                          // 文字颜色
      opacity: 1,                                // 透明度（1-不透明，0-透明）
      isAPG: false,                              // 是否在APG中使用
    };
    const gameInfoDL = {
      openNative: '0',        // 拉起后是否打开原生页面，false为打开web页面
      openNativeParams: {},   // 拉起原生页面用到的参数，由客户端提供
      gameId: '10014',        // 助手gameId
      icon: '',               // 显示图标
      title: '',              // 显示标题
      context: '',            // 显示文案
      winWidth: 0,            // 屏幕宽度
      action: 20002,
      system: 'Android',      // 指定系统
      channelId: 1,
      jumpToUrl: '',          // 跳转链接（不带参）
      urlParams: '',          // 跳转页面携带参数
      reportId: '',           // 埋点ID（客态页无法传递用户态）
      reportGame: '',         // 埋点对应游戏业务
      pageDomain: 'qq.com',   // common.js会将父页面域设置为"qq.com",会产生跨域问题
      argEx: '0',             // 是否扩展拉起参数，暂时只发现CFM、DNF需要
      isGameHelper: '0',      // 是否是大通版（腾讯游戏助手）打开的页面
    };
    const bannerDL = {
      iframeW: 0,
      iframeH: 0,
      style: '.%styleClass%{width:%iframeW%px;height:%iframeH%px;position:fixed;%position%:0;left:0;z-index:999;overflow:hidden;opacity:%opacity%}',
      html: '<iframe class="downloadbar %styleClass%" id="%iFrameName%" src="%src%" allowtransparency="true" frameborder="0" name="%iFrameName%"></iframe>',
      accMul(s1, s2) {
        let m = 0;
        const s1String = s1.toString();
        const s2String = s2.toString();
        try {
          m += s1String.split('.')[1].length;
        } catch (e) {
        }
        try {
          m += s2String.split('.')[1].length;
        } catch (e) {
        }
        return Number(s1String.replace('.', '')) * Number(s2String.replace('.', '')) / (10 ** m);
      },
      accDiv(arg1, arg2) {
        let t1 = 0;
        let t2 = 0;
        let r1 = 0;
        let r2 = 0;
        try {
          t1 = arg1.toString().split('.')[1].length;
        } catch (e) {
        }
        try {
          t2 = arg2.toString().split('.')[1].length;
        } catch (e) {
        }
        r1 = Number(arg1.toString().replace('.', ''));
        r2 = Number(arg2.toString().replace('.', ''));
        return this.accMul((r1 / r2), 10 ** (t2 - t1));
      },
      iframeWidth() {
        // 浏览器的兼容
        return window.innerWidth || document.documentElement.clientWidth;
      },
      iframeHeight(scale) {
        const w = this.iframeW < 320 ? 420 : this.iframeW;
        return Math.round(this.accMul(w, scale));
      },
      setIFrame(ginfo, iframeParams = {}) {
        const params = iframeParams;
        bannerParamsDL.page = `//${location.host}${bannerParamsDL.page}`;
        Object.keys(params).forEach((p) => {
          if (bannerParamsDL[p] === undefined) {
            throw `setIFrame args[0] : ${p} is redundant params`;
          } else if (params[p] !== '' && params[p] !== null && typeof params[p] !== 'object') {
            if (p === 'scale' && params[p] > 0.5) {
              params[p] = 0.18;
            }
            bannerParamsDL[p] = params[p];
          }
        });
        Object.keys(ginfo).forEach((g) => {
          if (gameInfoDL[g] === undefined) {
            throw `setIFrame args[1] : ${g} is redundant params`;
          } else if (ginfo[g] !== '' && ginfo[g] !== null && typeof ginfo[g] !== 'object') {
            gameInfoDL[g] = ginfo[g];
          }
        });
        gameInfoDL.urlParams = gameInfoDL.urlParams === '' ? '' : btoa(gameInfoDL.urlParams);
        gameInfoDL.bg = bannerParamsDL.background;      // comFun.getUrlParam会把background过滤掉
        gameInfoDL.color = bannerParamsDL.color;
        gameInfoDL.opacity = bannerParamsDL.opacity;
        if (gameInfoDL.pageDomain !== '') {
          document.domain = gameInfoDL.pageDomain;
        }
        console.log('gameInfoDL:', gameInfoDL);
        this.createBanner();
        return;
      },
      makeUrl() {
        const url = bannerParamsDL.page;
        if (gameInfoDL.winWidth === 0 || gameInfoDL.winWidth === undefined) {
          // gameInfoDL.winWidth = this.iframeWidth();
          gameInfoDL.winWidth = '0';
        }
        gameInfoDL.scale = bannerParamsDL.scale;
        // 获取系统
        const agent = navigator.userAgent;
        if (agent.indexOf('iPhone') >= 0) {
          gameInfoDL.system = 'iPhone';
        } else if (agent.indexOf('Android') >= 0) {
          gameInfoDL.system = 'android';
        }
        let urlParams = [];
        Object.keys(gameInfoDL).forEach((g) => {
          if (gameInfoDL[g] !== undefined && gameInfoDL[g] !== null && gameInfoDL[g] !== '') {
            urlParams.push(`${g}=${gameInfoDL[g]}`);
          }
        });
        urlParams = urlParams.join('&');
        console.log(`${url}?${urlParams}`);
        return `${url}?${urlParams}`;
      },
      createBanner() {
        this.iframeW = this.iframeWidth();
        this.iframeH = this.iframeHeight(bannerParamsDL.scale);
        if (bannerParamsDL.position !== 'top' && bannerParamsDL.position !== 'bottom') {
          throw `args[0]: "${bannerParamsDL.position}" error`;
        }
        const head = document.head || document.getElementsByTagName('head')[0];
        const body = document.body || document.getElementsByTagName('body')[0];
        const html = this.html.replace('%styleClass%', bannerParamsDL.attrClass).replace(/%iFrameName%/g, bannerParamsDL.attrName)
          .replace('%src%', this.makeUrl());
        const style = this.style.replace('%styleClass%', bannerParamsDL.attrClass).replace('%iframeW%', this.iframeW)
          .replace('%iframeH%', this.iframeH)
          .replace('%position%', bannerParamsDL.position)
          .replace('%opacity%', bannerParamsDL.opacity);
        const styleNode = document.createElement('style');
        const iframeDiv = document.createElement('div');
        const scripts = document.body.getElementsByTagName('script');
        const first = document.body.firstChild;

        // 增加iframe窗口，并用div节点包裹
        iframeDiv.setAttribute('class', bannerParamsDL.attrClass);
        iframeDiv.innerHTML = html;
        if (!bannerParamsDL.isAPG) {
          // 避免添加到body中script标签之后
          try {
            body.insertBefore(iframeDiv, scripts[0]);
          } catch (error) {
            if (scripts.length > 1) {
              body.insertBefore(iframeDiv, scripts[1]);
            } else {
              throw 'scripts[0] is not a child of body';
            }
          }
        } else {
          // 兼容APG直接生成的代码（div嵌套script标签）,直接添加到body头部位置
          body.insertBefore(iframeDiv, first);
        }

        // 增加style节点
        styleNode.appendChild(document.createTextNode(style));
        head.appendChild(styleNode);
        return;
      },
      // 重载iframe宽高
      resize() {
        const iFrameId = bannerParamsDL.attrName;
        this.iframeW = this.iframeWidth();
        this.iframeH = this.iframeHeight(bannerParamsDL.scale);
        const iFrameDOM = document.getElementById(iFrameId);
        iFrameDOM.style.width = `${this.iframeW}px`;
        iFrameDOM.style.height = `${this.iframeH}px`;
      },
    };
    let url;
    let action;
    const argEx = '1';
    console.log('Vue.prototype?.$storeInstance', Vue.prototype.$actInfo);
    let actUrl = window.location.href; // 修改由于过度转义引起的拉起异常(跳转到未知页面)
    actUrl = common.tool.setUrlParam('subGameId', subGameId, actUrl);
    console.log('footer---------------actUrl', actUrl);
    // 强制更新成活动traceId
    const traceId = window.ceibaTraceId;
    actUrl = common.tool.setUrlParam('trace_id', traceId, actUrl);
    if (navigator.userAgent.indexOf('iPhone') >= 0) {
      action = common.tool.getQueryparams('action') || 20002;
      url = actUrl;
    } else {
      action = common.tool.getQueryparams('action') || 20003;
      // jumpUrl中转时，会将cf/NewYear转换成cfewYear
      if (parseInt(subGameId, 10) === 20006 || parseInt(subGameId, 10) === 20003) {
        url = actUrl;
      } else {
        url = `http://mwegame.qq.com/act/jumpUrl?acturl=${actUrl}`;
      }
    }
    console.log('footer---------------', gameId, subGameId, actUrl);
    const ginfo = {
      title: astConfig.BB?.GAMEINFO[gid]?.title || astConfig.BB?.GAMEINFO[subGameId]?.title || 'DNF助手',
      argEx,
      gameId,
      jumpToUrl: url,
      winWidth: window.innerWidth || document.documentElement.clientWidth,
      action,
    };
    console.log('bannerDL done');
    bannerDL.setIFrame(ginfo, { page: 'https://mwegame.qq.com/act/dnf/downloadBanner/indexNew' });
    window.onresize = function () {
      bannerDL.resize();
    };
  },
};
